





















































import Vue from 'vue';
import Component from 'vue-class-component';

import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import _ from 'lodash';

const Props = Vue.extend({
	props: {
		/** The v-model value */
		value: {
			type: String,
			default: ''
		},
		dateMin: {
			type: String,
			default: ''
		},
		dateMax: {
			type: String,
			default: ''
		},
		datePickerRules: {
			type: [Array, Object],
			default: () => ([])
		},
		startDate: {
			type: String,
			default: ''
		},
		disabled: {
			type: Boolean,
			default: false
		}
	}
});

/** DatePicker from Vue Dot with special configuration */
@Component({
	// Define custom v-model,
	// prop name is value, event name is change
	model: {
		prop: 'value',
		event: 'change'
	}
})
export default class P2DatePicker extends Props {
	internalPickerDate: string | null = null;

	isoDateToday: string = dayjs().format('YYYY-MM');

	resetInternalPickerDate(error: boolean): void {
		this.internalPickerDate = error ? this.isoDateToday : null;
	}

	getWeekday(date: string): string {
		return dayjs(date).locale('fr').format('dddd').charAt(0).toUpperCase();
	}

	// computedValue is computed property
	// with a setter and a getter
	// Return the value
	get computedValue(): string {
		return this.value;
	}

	// Emit the updated value
	set computedValue(value: string) {
		this.$emit('change', value);
	}

	get isIE(): boolean {
		const userAgent = _.get(window, 'navigator.userAgent', '');
		return _.includes(userAgent, 'MSIE') || _.includes(userAgent, 'Trident/');
	}
}
